import { useMemo } from "react";
import {
  BASIC_BLACK,
  BASIC_GRAY,
  BASIC_LIGHT_BLUE,
  BASIC_YELLOW,
} from "../../constants/colors";
import { OrderStatus } from "../../ducks/order";
import { Badge } from "../atoms/Badge";

type Props = {
  status: OrderStatus;
};

export const OrderHistoryBadge: React.FC<Props> = ({ status }) => {
  const color = useMemo(() => {
    switch (status) {
      case OrderStatus.New:
        return BASIC_LIGHT_BLUE;
      case OrderStatus.Registered:
      case OrderStatus.Cooking:
        return BASIC_YELLOW;
      case OrderStatus.Completed:
      case OrderStatus.Canceled:
        return BASIC_GRAY;
      default:
        return BASIC_LIGHT_BLUE;
    }
  }, [status]);

  const textColor = useMemo(() => {
    switch (status) {
      case OrderStatus.Registered:
      case OrderStatus.Cooking:
        return BASIC_BLACK;
      default:
        return undefined;
    }
  }, [status]);

  return <Badge color={color} text={status.valueOf()} textColor={textColor} />;
};
